
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M35.163 11.2l5.637 5.637a.611.611 0 010 .863L27.15 31.35l-5.8.644a1.216 1.216 0 01-1.344-1.344l.644-5.8L34.3 11.2a.611.611 0 01.863 0zm10.125-1.431l-3.05-3.05a2.444 2.444 0 00-3.45 0L36.575 8.93a.611.611 0 000 .863l5.637 5.637a.611.611 0 00.863 0l2.212-2.212c.95-.957.95-2.5 0-3.45zM34 27.637V34H14V14h14.363c.2 0 .387-.081.53-.219l2.5-2.5a.75.75 0 00-.53-1.281H13a3 3 0 00-3 3v22a3 3 0 003 3h22a3 3 0 003-3v-9.863c0-.668-.806-1-1.281-.53l-2.5 2.5a.768.768 0 00-.219.53z","fill":"#535353","fill-rule":"nonzero"}})])
          )
        }
      }
    